'use strict';

// core version + modules:
import Swiper, { Navigation, A11y, Autoplay } from 'swiper';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/a11y';
import 'swiper/css/autoplay';


const SliderSingle = {
    els: null,
    init: function () {
        SliderSingle.els = document.querySelectorAll('.f-carousel');
        if (SliderSingle.els && SliderSingle.els.length > 0) {
            SliderSingle.els.forEach(el => {
                SliderSingle.create(el);
            });
        }
        console.log('f-carousel init');
    },
    create: function (el) {
        const slider = el.querySelector('.swiper');

        // Find navigation buttons INSIDE this specific carousel instance
        const nextBtn = el.querySelector('.f-carousel__navigation-next');
        const prevBtn = el.querySelector('.f-carousel__navigation-prev');

        let swiper = null;

        // 1. Select the specific parent container
        const heroContainer = document.querySelector('.f-heroHome__container');

        // 2. Find the swiper and count slides ONLY inside that container
        // We use optional chaining (?.) in case the container doesn't exist on certain pages
        const heroSlideCount = heroContainer ? heroContainer.querySelectorAll('.swiper-slide').length : 0;

        //console.log('heroSlideCount123', heroSlideCount);

        swiper = new Swiper(slider, {
            modules: [Navigation, A11y, Autoplay],
            a11y: true,
            spaceBetween: 2,
            slidesPerView: 1,
            loop: heroSlideCount > 1 ? true : false,
            autoplay: heroSlideCount > 1 ? {
                delay: 7000,                // 7 seconds
                disableOnInteraction: false, // Restarts autoplay after user clicks/drags
                pauseOnMouseEnter: true      // Pauses when hovering so users can read
            } : false,
            speed: 600,
            autoHeight: true,
            navigation: {
                nextEl: nextBtn, // Pass the actual DOM element instead of a string
                prevEl: prevBtn, // Pass the actual DOM element instead of a string
            },
            breakpoints: {
                980: {
                    autoHeight: false
                }
            },
            on: {
                slideChange: function () {
                    SliderSingle.pauseMedia(this);
                }
            }
        });
    },
    pauseMedia: function (swiper) {
        // Safety check: ensure the instance and slides exist
        if (!swiper || !swiper.slides) return;

        swiper.slides.forEach(slide => {
            slide.querySelectorAll('video').forEach(video => { //video mp4
                video.pause();
            });


            slide.querySelectorAll('iframe').forEach(iframe => {// Reset <iframe>
                const src = iframe.getAttribute('src');
                if (src) {
                    let newSrc = src.replace(/autoplay=1/g, 'autoplay=0');
                    iframe.setAttribute('src', newSrc);
                }

            });
        });
    }
};

export default SliderSingle;